//import 'bulma-start/css/main.css';

// Bulma Customized Theme
import './assets/css/theme.css';

// ActiveCues Theme
import './assets/css/custom.css';

// Balloon Tooltips
import 'balloon-css/balloon.css';

// Pretty Checkboxes
import 'pretty-checkbox/dist/pretty-checkbox.css';


// WEBPACK FOOTER //
// ./src/theme.js